import config from "@/utils/Config";
import {get } from "@/utils/request";

export function getLinksList(params = {}) {
    return get(config.BASE_URL, config.getLinksListUrl, params)
}